import { isValidPhoneNumber } from "libphonenumber-js/min"
import type { ValidatorRule } from "rc-field-form/lib/interface"

import { placeholders } from "../../constants/placeholders"

const isValidPhone = (value: unknown): boolean => {
  const cleanValue = typeof value === "string" ? value.trim() : ""

  if (!cleanValue) return true

  const phoneRegex = /^[+\-\s\d()]+$/
  if (!phoneRegex.test(cleanValue)) return false

  const digits = cleanValue.replace(/\D/g, "")
  const normalized =
    !cleanValue.startsWith("+") && digits.length === 10
      ? `+1${digits}`
      : cleanValue

  return isValidPhoneNumber(normalized)
}

const validatePhone: ValidatorRule["validator"] = async (rule, value) => {
  const cleanValue = typeof value === "string" ? value.trim() : ""

  if (!cleanValue && !rule?.required) {
    return Promise.resolve()
  }

  if (!cleanValue) {
    return Promise.reject(new Error("Please enter phone number"))
  }

  if (!isValidPhone(cleanValue)) {
    return Promise.reject(
      new Error(`Please enter a valid phone number ${placeholders.phone}`)
    )
  }

  return Promise.resolve()
}

export { isValidPhone, validatePhone }
